/* The styles below can be overridden using the className prop, */
/* which can target child classes by their name. */
/* If any field names are refactored or renamed, make sure to search for all instances of this prop usage. */
/* Currently, this is only used in ProductCardFields.less for grid styles. */

.metricScaleContainerLabel {
  flex-grow: 1;
  padding-right: 2px;
  color: var(--label-color);
}

.metricScaleContainerXSmall {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  flex: auto;
}

.metricScaleContainerXSmallABS {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: auto;
  line-height: 1;
  padding-top: 6px;
}

.metricScaleContainerXSmallScale {
  display: flex;
  align-items: flex-end;
  margin: 0 1px;
}

.metricScaleContainerSmall {
  min-height: 4rem;
  line-height: 1;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.metricScaleContainerSmallTitle {
  font-size: 1rem;
  color: var(--text-color);
  min-height: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.metricScaleContainerSmallIcon {
  color: var(--icon-color);
  margin-right: 0.2rem;
  font-size: 1.3rem;
  display: flex;
}

.metricScaleContainerMedium {
  min-height: 2rem;
  line-height: 1;
}

.metricScaleContainerMediumWrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--background-color);
  margin-top: calc(var(--gap-small) / 2);
}

.metricScaleContainerMediumTitle {
  width: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1rem;
  color: var(--text-color);
  padding-right: 4px;
}

.metricScaleContainerMediumIcon {
  color: var(--icon-color);
  font-size: 1.2rem;
  display: flex;
  padding-right: var(--gap-small);
}

.metricScaleContainerMediumScale {
  flex-basis: 50%;
}

.metricScaleContainerLarge {
  min-height: 2.6rem;
  line-height: 1;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--background-color);
  padding-left: var(--gap-small);
}

.metricScaleContainerLargeIcon {
  color: var(--icon-color);
  font-size: 1.8rem;
  display: flex;
  align-items: center;
  margin-right: var(--gap-small);
}

.metricScaleContainerLargeTitle {
  flex-grow: 1;
  padding-right: 2px;

  font-size: 1.5rem;
  color: var(--label-color);
}

.metricScaleContainerLargeABS {
  font-size: 1.6rem;
  color: var(--text-color);
  margin-left: auto;
  margin-right: var(--gap-small);
}

.metricScaleContainerLargeScale {
  flex-basis: 50%;
  flex-shrink: 0;
}

.metricScaleContainerActive {
  --icon-color: var(--color-neutral-lightest);
  --label-color: var(--color-neutral-lightest);
  --text-color: var(--color-white);
  --background-color: var(--color-neutral-dark);
}

.metricScaleContainerInactive {
  --icon-color: var(--color-neutral-light);
  --label-color: var(--color-neutral-light);
  --text-color: var(--color-neutral-light);
  --background-color: none;

  .spreadV2LabelLink {
    pointer-events: none;
    color: var(--text-color) !important;
  }
}

.metricScaleContainerInCard {
  &.metricScaleContainerLarge,
  .metricScaleContainerMediumWrapper {
    padding-left: 0;
    background-color: transparent;
  }
}
